import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

export interface Photo {
  id: string;
  title: string;
  description?: string;
  url: string;
  thumbnailUrl: string;
  width: number;
  height: number;
  category?: string;
  createdAt: string;
}

interface PhotoGridProps {
  photos: Photo[];
  className?: string;
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ photos, className }) => {
  const navigate = useNavigate();

  const handlePhotoClick = (id: string) => {
    navigate(`/photo/${id}`);
  };

  return (
    <div className={cn('photo-grid', className)}>
      {photos.map((photo) => (
        <div 
          key={photo.id}
          className="group relative overflow-hidden aspect-square cursor-pointer animate-fade-in rounded-md"
          onClick={() => handlePhotoClick(photo.id)}
        >
          <img
            src={photo.thumbnailUrl}
            alt={photo.title}
            loading="lazy"
            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105 rounded-md"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
            <h3 className="text-white font-playfair text-lg">{photo.title}</h3>
            {photo.category && (
              <span className="text-white/80 text-sm uppercase tracking-wide">
                {photo.category}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PhotoGrid;
